const cardTypes = {
  VISA: {
    enableCVV: true,
  },
  MASTER_CARD: {
    enableCVV: true,
  },
  AMEX: {
    enableCVV: true,
  },
  VISAELECTRON: {
    enableCVV: true,
  },
  MAESTRO: {
    enableCVV: false,
  },
  UNIONPAY: {
    enableCVV: true,
  },
  DISCOVER: {
    enableCVV: true,
  },
  JCB: {
    enableCVV: true,
  },
  CARTES_BANCAIRES: {
    enableCVV: true,
  },
  INVALID: {
    enableCVV: true,
  },
};

export default cardTypes;
